<template>
  <div ref="context-menu" id="context-menu" v-click-outside="doHide">
    <b-list-group>
      <template v-for="(item, index) in menus">
        <b-list-group-item
          class="context-menu-item"
          :key="index"
          @click="clickMenuItem(item, index)"
        >
          <i
            v-if="item.icon"
            class="context-menu-icon fa"
            :class="item.icon"
          ></i>
          <span>{{ item.label }}</span>
        </b-list-group-item>
      </template>
    </b-list-group>
  </div>
</template>
<script>
export default {
  name: "context-menu",
  props: {
    menus: {}
  },
  data() {
    return {
      data: {},
      contextMenuWidth: 0,
      contextMenuHeight: 0
    };
  },
  methods: {
    clickMenuItem(item, index) {
      this.$emit("click", { menu: item, index, data: this.data });
      this.doHide();
    },
    doShow(data, $event) {
      $event.preventDefault();
      this.data = data;
      var menu = this.$refs["context-menu"];
      if (!this.contextMenuWidth || !this.contextMenuHeight) {
        menu.style.visibility = "hidden";
        menu.style.display = "block";
        this.contextMenuWidth = menu.offsetWidth;
        this.contextMenuHeight = menu.offsetHeight;
        menu.removeAttribute("style");
      }
      menu.style.width = this.contextMenuWidth + 2 + "px";

      if (this.contextMenuWidth + $event.layerX >= window.innerWidth) {
        menu.style.left = $event.layerX - this.contextMenuWidth + "px";
      } else {
        menu.style.left = $event.layerX + "px";
      }

      if (this.contextMenuHeight + $event.layerY >= window.innerHeight) {
        menu.style.top = $event.layerY - this.contextMenuHeight + "px";
      } else {
        menu.style.top = $event.layerY + "px";
      }
      menu.classList.add("active");
    },
    doHide() {
      var menu = this.$refs["context-menu"];
      menu.classList.remove("active");
    }
  }
};
</script>
<style lang="scss">
#context-menu {
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  display: none;
  list-style: none;
  position: absolute;
  z-index: 2147483647;
  background-color: white;
  border: 1px solid #ebebeb;
  border-bottom-width: 0px;
  &.active {
    display: block;
  }
  .context-menu-item {
    display: flex;
    cursor: pointer;
    align-items: center;
    border-bottom: 1px solid #ebebeb;
    .context-menu-icon {
      top: 1px;
      position: relative;
      margin-right: 10px;
    }
    &:hover {
      background-color: #ebebeb;
    }
  }
}
</style>
